export const NAME_VALIDATION = {
  required: { value: true, message: 'Name is required.' },
};
